module.exports = __webpack_public_path__ + "static/EGR_FlashPage_3-7c4cf582e9e3cab36507006505d9e11a.jpg";